import axios from "axios";
export default {
  namespaced: true,
  state: {
    item_sub_types: [],
  },
  getters: {
    item_sub_types(state) {
      return state.item_sub_types;
    },
  },
  mutations: {
    SET_ITEM_SUB_TYPES(state, item_sub_types) {
      state.item_sub_types = item_sub_types;
    },
    ADD_ITEM_SUB_TYPE(state, item_sub_type) {
      state.item_sub_types.unshift(item_sub_type);
    },
    EDIT_ITEM_SUB_TYPE(state, item_sub_type) {
      var index = state.item_sub_types.findIndex(
        (a) => a.id == item_sub_type.id
      );
      state.item_sub_types.splice(index, 1, item_sub_type);
    },
    DELETE_ITEM_SUB_TYPE(state, request) {
      state.item_sub_types = state.item_sub_types.filter(
        (i) => i.id != request.id
      );
    },
  },
  actions: {
    async get_item_sub_types({ commit }) {
      let response = await axios.get("/item_sub_types");
      commit("SET_ITEM_SUB_TYPES", response.data);
    },
    async add_item_sub_type({ commit }, request) {
      try {
        let response = await axios.post("/item_sub_type", request);
        commit("ADD_ITEM_SUB_TYPE", response.data);
        return response.data;
      } catch (err) {
        throw err.response ? err.response.data.error : err.message;
      }
    },
    async edit_item_sub_type({ commit }, request) {
      let response = await axios.put("/item_sub_type", request);
      commit("EDIT_ITEM_SUB_TYPE", response.data);
      return response.data;
    },
    async delete_item_sub_type({ commit }, request) {
      await axios.delete("/item_sub_type/" + request.id);
      commit("DELETE_ITEM_SUB_TYPE", request);
    },
  },
};
